export default "__VITE_ASSET__D0$Oa011__"